













import Vue from "vue";
import PageLoader from "./PageLoader.vue";
import Top from "./Top.vue";
import Bottom from "./Bottom.vue";

export default Vue.extend({
  components: {
    PageLoader,
    Top,
    Bottom
  },
  computed: {
    extraClasses() {
      var about = false;

      if (this.$route.path == "/about") {
        about = true;
      }

      return {
        "page-about": about
      };
    }
  }
});
